export { default } from './Purchases.vue';